import { Link } from 'react-router-dom';

const serviceLinks = [
  { label: 'Paver Driveways', href: '/services/paver-driveways' },
  { label: 'Paver Patios', href: '/services/paver-patios' },
  { label: 'Pool Deck Pavers', href: '/services/pool-deck' },
  { label: 'Walkways & Pathways', href: '/services/walkways' },
  { label: 'Retaining Walls', href: '/services/retaining-walls' },
  { label: 'Outdoor Living', href: '/services/outdoor-living' },
  { label: 'Hardscape Design', href: '/services/hardscape-design' },
];

const locationLinks = [
  { label: 'Paver Installation Tampa', href: '/locations/tampa' },
  { label: 'Paver Installation St. Pete', href: '/locations/st-petersburg' },
  { label: 'Paver Installation Clearwater', href: '/locations/clearwater' },
  { label: 'Paver Installation Tarpon Springs', href: '/locations/tarpon-springs' },
];

const quickLinks = [
  { label: 'About Parkside Pavers', href: '/about' },
  { label: 'Project Gallery', href: '/gallery' },
  { label: 'Get a Free Estimate', href: '/contact' },
  { label: 'Contact Us', href: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-parkside-darker text-white">
      {/* Top CTA bar */}
      <div className="bg-parkside-green">
        <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <p className="text-white font-bold text-xl">Ready to Transform Your Outdoor Space?</p>
            <p className="text-white/70 text-sm mt-0.5">Get your free design consultation — no commitment required.</p>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <a
              href="tel:813-404-6313"
              className="flex items-center gap-2 bg-white/15 border border-white/25 text-white font-semibold px-5 py-2.5 rounded-lg hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              <span className="w-4 h-4 inline-flex items-center justify-center">
                <i className="ri-phone-fill" />
              </span>
              (813) 404-6313
            </a>
            <Link
              to="/contact"
              className="bg-parkside-amber text-white font-bold px-5 py-2.5 rounded-lg hover:bg-parkside-amber/90 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              Free Estimate
            </Link>
          </div>
        </div>
      </div>

      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-6 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
          {/* Brand column - wider */}
          <div className="lg:col-span-2">
            <img
              src="https://www.parksidepavers.com/files/user/logo.svg"
              alt="Parkside Pavers"
              className="h-12 w-auto mb-5 brightness-0 invert"
            />
            <p className="text-white/55 text-sm leading-relaxed mb-6 max-w-xs">
              Tampa Bay&apos;s trusted ICPI-certified paver installation specialists. Custom driveways, patios, walkways, pool decks, and outdoor living spaces designed to last.
            </p>
            <div className="space-y-2.5">
              <a
                href="tel:813-404-6313"
                className="flex items-center gap-3 text-sm text-white/70 hover:text-parkside-gold transition-colors cursor-pointer group"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-lg flex-shrink-0 group-hover:bg-parkside-amber/20 transition-colors">
                  <i className="ri-phone-fill text-parkside-amber text-sm" />
                </div>
                <span className="font-semibold">(813) 404-6313</span>
              </a>
              <div className="flex items-center gap-3 text-sm text-white/70">
                <div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-lg flex-shrink-0">
                  <i className="ri-map-pin-fill text-parkside-amber text-sm" />
                </div>
                <span>Tampa, FL — Serving All of Tampa Bay</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-white/70">
                <div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-lg flex-shrink-0">
                  <i className="ri-time-fill text-parkside-amber text-sm" />
                </div>
                <span>Mon–Sat, 8am–6pm</span>
              </div>
            </div>
            {/* Trust badges */}
            <div className="flex items-center gap-4 mt-6">
              <div className="flex items-center gap-1">
                {[1,2,3,4,5].map((s) => (
                  <span key={s} className="w-3 h-3 inline-flex items-center justify-center">
                    <i className="ri-star-fill text-parkside-gold text-xs" />
                  </span>
                ))}
              </div>
              <span className="text-white/50 text-xs">5.0 on Google & Yelp</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h5 className="text-xs font-bold uppercase tracking-widest text-parkside-amber mb-5">Services</h5>
            <ul className="space-y-2.5">
              {serviceLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-white/55 hover:text-white transition-colors cursor-pointer flex items-center gap-1.5 group"
                  >
                    <span className="w-3 h-3 inline-flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                      <i className="ri-arrow-right-s-line text-parkside-amber text-xs" />
                    </span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Locations */}
          <div>
            <h5 className="text-xs font-bold uppercase tracking-widest text-parkside-amber mb-5">Service Areas</h5>
            <ul className="space-y-2.5">
              {locationLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-white/55 hover:text-white transition-colors cursor-pointer flex items-center gap-1.5 group"
                  >
                    <span className="w-3 h-3 inline-flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                      <i className="ri-arrow-right-s-line text-parkside-amber text-xs" />
                    </span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="text-xs font-bold uppercase tracking-widest text-parkside-amber mb-5">Company</h5>
            <ul className="space-y-2.5 mb-7">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-white/55 hover:text-white transition-colors cursor-pointer flex items-center gap-1.5 group"
                  >
                    <span className="w-3 h-3 inline-flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                      <i className="ri-arrow-right-s-line text-parkside-amber text-xs" />
                    </span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="bg-white/5 rounded-xl p-4 border border-white/10">
              <p className="text-white font-bold text-sm mb-0.5">ICPI Certified</p>
              <p className="text-white/50 text-xs leading-snug">Interlocking Concrete Pavement Institute certified installer</p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-white/35 text-xs">
            &copy; 2026 Parkside Pavers. All rights reserved. Serving the Greater Tampa Bay Area.
          </p>
          <p className="text-white/25 text-xs">Licensed &bull; Bonded &bull; Insured &bull; ICPI Certified</p>
        </div>
      </div>
    </footer>
  );
}
